class LoginController {
  constructor(Account, growl, $http, store, $state) {
    "ngInject";

    let vm = this;
    vm.user = {
      username: "",
      password: ""
    };
    vm.login = login;

    function login(){
      Account.login(vm.user.username, vm.user.password).then(res => {
        growl.info("Login effettuato con successo!");
        store.set("token", "Bearer " + res.data.id_token);
        $http.defaults.headers.common.Authorization = store.get("token");
        $state.go("dashboard.list", {modelEnum: 'CULTURE'});
      }, err => {
        growl.error("Username o password non corretti. Riprovare");
      })
    }
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/login/login.controller.js